var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_7068)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.33 6H3.67C3.3 6 3 6.31 3 6.7V17.3C3 17.69 3.3 18 3.67 18H20.34C20.71 18 21.01 17.69 21.01 17.3V6.7C21.01 6.31 20.71 6 20.34 6H20.33ZM19.67 16.6H4.33V7.4H19.66V16.59L19.67 16.6ZM9.27008 11.2402H7.83008V12.7602H9.27008V11.2402ZM10.3301 11.2402H11.7701V12.7602H10.3301V11.2402ZM14.2701 11.2402H12.8301V12.7602H14.2701V11.2402ZM15.3398 11.2402H16.7798V12.7602H15.3398V11.2402ZM7.70953 8.82031H6.26953V10.3403H7.70953V8.82031ZM8.78027 8.82031H10.2203V10.3403H8.78027V8.82031ZM12.7203 8.82031H11.2803V10.3403H12.7203V8.82031ZM13.7803 8.82031H15.2203V10.3403H13.7803V8.82031ZM17.7203 8.82031H16.2803V10.3403H17.7203V8.82031ZM6.26953 13.6602H7.70953V15.1802H6.26953V13.6602ZM15.2303 13.6602H8.78027V15.1802H15.2303V13.6602ZM16.2803 13.6602H17.7203V15.1802H16.2803V13.6602Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_7068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white",
    transform: "translate(3 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShortcut);
export default __webpack_public_path__ + "static/media/ico-shortcut.b5296d24e2cce50be99f479c0a3ce92b.svg";
export { ForwardRef as ReactComponent };